module.exports = __webpack_public_path__ + "static/media/twitter-col-icon.db230314.svg";